import type { Ref } from 'vue'

interface MarketingSectionViewOptions {
  page: string
  section: string
  target: Ref<HTMLElement | null>
}

export function useMarketingSectionView({ page, section, target }: MarketingSectionViewOptions): void {
  const route = useRoute()
  const { $posthog } = useNuxtApp()
  let observer: IntersectionObserver | null = null

  onMounted(() => {
    if (!target.value || !('IntersectionObserver' in window)) {
      return
    }

    observer = new IntersectionObserver((entries) => {
      if (!entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.35)) {
        return
      }

      $posthog?.capture('marketing_section_viewed', {
        page,
        path: route.path,
        section,
        label: section,
        destination: 'section',
      })
      observer?.disconnect()
      observer = null
    }, { threshold: [0.35] })

    observer.observe(target.value)
  })

  onBeforeUnmount(() => observer?.disconnect())
}

